module.exports = __webpack_public_path__ + "21438f20a92c6862adbdc41e5df3586a.jpg";